import script from "./TotalNum.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalNum.vue?vue&type=script&setup=true&lang=js"

import "./TotalNum.vue?vue&type=style&index=0&id=2e07d108&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e07d108"]])

export default __exports__